import { createSelector, createSelectorMemoized } from '@base-ui/utils/store';
const selectRecurringEventsPlugin = state => state.recurringEventsPlugin;

/** Memoized selectors that delegate to the recurring-events plugin. */
export const schedulerRecurringEventSelectors = {
  presets: createSelectorMemoized(state => state.adapter, selectRecurringEventsPlugin, (adapter, recurringEventsPlugin, date) => recurringEventsPlugin?.computePresets(adapter, date) ?? null),
  defaultPresetKey: createSelectorMemoized(state => state.adapter, selectRecurringEventsPlugin, (adapter, recurringEventsPlugin, rule, occurrenceStart) => recurringEventsPlugin?.getDefaultPresetKey(adapter, rule, occurrenceStart) ?? null),
  isSameRRule: createSelector(state => state.adapter, selectRecurringEventsPlugin, (adapter, recurringEventsPlugin, rruleA, rruleB) => {
    if (!rruleA && !rruleB) {
      return true;
    }
    if (!rruleA || !rruleB) {
      return false;
    }
    return recurringEventsPlugin?.isSameRRule(adapter, rruleA, rruleB) ?? false;
  })
};